import { render, staticRenderFns } from "./Agreed.vue?vue&type=template&id=674b2f87&scoped=true"
import script from "./Agreed.vue?vue&type=script&lang=js"
export * from "./Agreed.vue?vue&type=script&lang=js"
import style0 from "./Agreed.vue?vue&type=style&index=0&id=674b2f87&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b2f87",
  null
  
)

export default component.exports